import React from 'react';
import { useSelector } from 'react-redux';
import './HeaderBar.css';
import logo from '../../icons/logistika.png';
import userIcon from '../../icons/8a.png';
import crownIcon from '../../icons/1k.png';
import crownIcon4 from '../../icons/5k.png';
import SideBarMenu from './SideBarMenu'

const HeaderBar = ({ userName }) => {

  const getCrownIcons = () => {
    const icons = [];
    icons.push(crownIcon);
    icons.push(crownIcon4);
    return icons;
  };

  const crownIcons = getCrownIcons();

  return (
    <>
      <SideBarMenu/>
      <div className="header-bar">
        <div className="left-section">
          <img src={logo} alt="Logistika Logo" className="logo" />
        </div>
        <div>
          <div className="right-section">
            <div className="user-info">
              <img src={userIcon} alt="User Icon" className="icon" />
            </div>
            <div className="contact-info">
              <span>{userName}</span>
            </div>
            <div className="crown-info">
              {crownIcons.map((icon, index) => (
                <img key={index} src={icon} alt={`Crown Icon ${index + 1}`} className="icon" />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderBar;
